<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud :ref="'usersCrud'" crudName="Usuários" newText="Novo Usuário" :table="table" :columns="columns"
          :options="options" :endPoint="endPoint" :enableAdd="true" :enableEdit="true" :enableDelete="true"
          :enableView="false" :enableReset="false" :dataForm="dataForm">
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "usersTable",
      usersCrud: {},
      pages: [],
      url: "",
      columns: ["id", "photo", "name", "access_nivel", "email", "actions"],
      tableData: ["id", "photo", "name", "access_nivel", "email"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["name", "access_nivel", "email"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          photo: "Foto",
          name: "Nome",
          access_nivel: "Nível de Acesso",
          email: "E-mail",
          actions: "Ações",
        },

        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          access_nivel: [
            {
              id: 1,
              text: "Usuario Padrão",
            },
            {
              id: 2,
              text: "Gestor Empresa",
            },
            {
              id: 6,
              text: "Administrador TI",
            },
            {
              id: 7,
              text: "Administrador RH",
            },
            {
              id: 8,
              text: "Administrador Geral",
            },
            {
              id: 10,
              text: "Usuário Cliente",
            },
          ],
        },
        templates: {
          access_nivel: function (h, row, index) {
            if (row.access_nivel == 1) {
              return "Usuário Padrão";
            } else if (row.access_nivel == 2) {
              return "Gestor Empresa";
            } else if (row.access_nivel == 6) {
              return "Administrador TI";
            } else if (row.access_nivel == 7) {
              return "Administrador RH";
            } else if (row.access_nivel == 8) {
              return "Administrador Geral";
            } else if (row.access_nivel == 10) {
              return "Usuário Cliente";
            }
          },
          photo: function (h, row) {
            if (row.photo) {
              return h(
                'img',
                {
                  attrs: {
                    src: row.photo,
                    width: '85',
                    height: '85',
                    style: 'border-radius: 50%; object-fit: cover;'
                  }
                }
              );
            } else {
              return h(
                'i',
                { class: 'fa fa-user-circle', style: { fontSize: '40px', color: '#bbb' } }
              );
            }
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "users/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        photo: "photo",
        name: "name",
        access_nivel: "access_nivel",
        email: "email",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    }
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>